import BidOfferTable from './BidOfferTable';

export default BidOfferTable;
